import { render } from "./BillToReceiveModal.vue?vue&type=template&id=3f65379e&scoped=true"
import script from "./BillToReceiveModal.vue?vue&type=script&lang=js"
export * from "./BillToReceiveModal.vue?vue&type=script&lang=js"

import "./BillToReceiveModal.vue?vue&type=style&index=0&id=3f65379e&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f65379e"]])

export default __exports__